import { render, staticRenderFns } from "./ArchivesManagementForm.vue?vue&type=template&id=9b470fb0&"
import script from "./ArchivesManagementForm.vue?vue&type=script&lang=js&"
export * from "./ArchivesManagementForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports